export const LCL_BRIDGE_COMMAND = {
  HEARTBEAT: 'heartbeat',
  REINITIALIZE: 'reinitialize',
  DOWNLOAD_FILE: 'downloadFile',
  CLOSE_CONTAINER_COMMAND: 'closeContainerCommand',
  HISTORY_BACK_COMMAND: 'historyBackCommand',
  CHANGE_HOST_HEADER_COMMAND: 'changeHostHeaderCommand',
  REDIRECT_COMMAND: 'redirectCommand',
  UNREAD_CONVERSATIONS_COUNT_CHANGE: 'unreadConversationsCountChange',
  SET_DRAWER_ON_CLOSE_COMMAND: 'setDrawerOnCloseCommand',
  TOGGLE_LOADER_COMMAND: 'toggleLoaderCommand',
  SAVE_STORAGE_KEYS_COMMAND: 'saveStorageKeysCommand',
  AUTHENTICATION_COMMAND: 'authenticationCommand',
  SHARE_MESSAGE_COMMAND: 'shareMessageCommand',
} as const

export type LclBridgeCommand = ValueOf<typeof LCL_BRIDGE_COMMAND>

export const LCL_BRIDGE_EVENT = {
  AUTHENTICATION: 'authentication',
  CLOSE_CONTAINER_EVENT: 'closeContainerEvent',
  HISTORY_BACK_EVENT: 'historyBackEvent',
  BREAKPOINT_CHANGED: 'breakpointChanged',
  QUICK_ACTIONS: 'quickActions',
} as const

export type LclBridgeEvent = ValueOf<typeof LCL_BRIDGE_EVENT>

export const LCL_BRIDGE_PROTOCOL = {
  IFRAME: 'IFRAME',
  WEBVIEW: 'WEBVIEW',
} as const

export type LclBridgeProtocol = ValueOf<typeof LCL_BRIDGE_PROTOCOL>

export const LCL_INIT_CHANNEL_MESSAGE = 'INIT_CHANNEL'
export const LCL_REFRESH_CHANNEL_MESSAGE = 'REFRESH_CHANNEL'
export const LCL_BROADCAST_CHANNEL_NAME = 'LCL_BROADCAST_CHANNEL'
